var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-link"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(!_vm.disabled)?_c('a',{staticClass:"tag is-delete",on:{"click":function($event){return _vm.$emit('remove')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }